import type { Theme, WithStyles } from "@envestnet/envreact-component-library";
import { createStyles } from "@envestnet/envreact-component-library";
import dashboardImage from "images/DashboardImageNoBackground.png";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      width: "100%",
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      background: theme.colors.background,
    },
    body: {
      display: "flex",
      flexDirection: "row",
      flex: 1,
      minHeight: 0,
    },
    content: {
      flexBasis: "624px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      alignSelf: "stretch",
      minHeight: 0,
    },
    footer: {
      marginTop: "auto",
      alignSelf: "flex-start",
    },
    dashboardImage: {
      alignSelf: "stretch",
      minHeight: 0,
      backgroundColor: theme.colors.background,
      backgroundImage: `url(${dashboardImage})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      flexGrow: 1,
    },
    "@media (max-width: 1220px)": {
      dashboardImage: {
        display: "none",
      },
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
